import Button from "@components/primitives/form/Button";
import Icon, { IconType } from "@components/primitives/icon/Icon";
import { useNavigate } from "react-router-dom";

type Props = {
  icon?: IconType["icon"];
  title: string;
  description: string;
  to?: string;
  toLabel?: string;
};
function Information({
  icon = "home",
  title,
  description,
  to,
  toLabel,
}: Props) {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (to) {
      navigate(to);
    }
  };
  return (
    <div className="bg-secondary p-5 w-full shadow-lg grid gap-5 grid-rows-1">
      <div>
        <h1 className="text-xl mb-5 font-bold flex items-center gap-5">
          <Icon icon={icon} />
          {title}
        </h1>

        <p className="text-secondary text-md">{description}</p>
      </div>
      {to && toLabel && (
        <Button theme="blue" onClick={handleButtonClick}>
          {toLabel}
        </Button>
      )}
    </div>
  );
}

export default Information;
